
import React from "react";


export const Contact = (props) => {

  return (
    <div>
      <div id="contact">
        <div className="container text-start">
          <div className="row">
            <div className="col-12 section-title">
              <h2>Nous contacter</h2>
              <p>Merci de nous contacter pour toute question ou demande de devis.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 contact-info">
              <div className="contact-item">
                <p>
                  <span><i className="fa fa-phone"></i> Téléphone</span>{" "}
                  {props.data ? props.data.phone : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span><i className="fa fa-envelope-o"></i> Email</span>{" "}
                  {props.data ? props.data.email : "loading"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
